const getNames = (arr = []) => {
    return arr.map(item => item.name);
};

const updateBroadcasters = (state = {}, action) => {
    const { type = null, datasource } = action;

    if (type === 'dataEngine_update_response') {
        if (datasource === 'schedule') {
            const {
                teams = {},
                nationalBroadcasts = {}
            } = action?.data || {};
            const homeBroadcasts = teams?.home?.broadcast || {};
            const awayBroadcasts = teams?.away?.broadcast || {};

            return {
                ...state,
                homeAudio: getNames(homeBroadcasts.radio),
                awayAudio: getNames(awayBroadcasts.radio),
                nationalAudio: getNames(nationalBroadcasts?.radio),
                homeTv: getNames(homeBroadcasts.tv),
                awayTv: getNames(awayBroadcasts.tv),
                nationalTv: getNames(nationalBroadcasts?.tv),
            };
        } 
        
        if (datasource === 'gumbo') {
            // GRAB TEAM NAMES
            const teams = action?.data?.liveData?.boxscore?.teams;
            return {
                ...state,
                homeName: teams?.home?.team?.teamName,
                awayName: teams?.away?.team?.teamName
            };
        }
    }

    return state;
};

export default updateBroadcasters;
